import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyle = makeStyles((theme) => ({
  textFieldSearch: {
    width: ({ showPlaceholder }) => (showPlaceholder ? 250 : 50),
    transition: "all .5s ease-in-out",
    marginRight: "15px",
    "&>div": {
      height: "37px",
    },
    borderColor: theme.palette.primary.main,
  },
  hrmsSearchIcon: {
    color: theme.palette.primary.main,
  },
}));

const SearchTextField = (props) => {
  const { handleSearch, search, ...rest } = props;
  const [showPlaceholder, setShowPlaceholder] = useState(false);
  const classes = useStyle({ showPlaceholder });
  const handleMouseOver = () => {
    setShowPlaceholder(true);
  };
  var sanitizedValue = "";
  sanitizedValue =
    typeof search === "string"
      ? search.replace(/<\/?script[^>]*>|<[^>]+>/gi, "")
      : "";
  const handleMouseOut = () => {
    if (!search) {
      setShowPlaceholder(false);
    }
  };

  useEffect(() => {
    if (search) {
      setShowPlaceholder(true);
    }
  }, [search]);

  return (
    <>
      <TextField
        className={classes.textFieldSearch}
        placeholder="Search"
        value={sanitizedValue}
        onChange={(e) => handleSearch(e)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon className={classes.hrmsSearchIcon} />
            </InputAdornment>
          ),
        }}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        {...rest}
      />
    </>
  );
};

export default SearchTextField;
